import { render } from "./FunnelPage.vue?vue&type=template&id=20213c72"
import script from "./FunnelPage.vue?vue&type=script&lang=js"
export * from "./FunnelPage.vue?vue&type=script&lang=js"

import "./FunnelPage.vue?vue&type=style&index=0&id=20213c72&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__